import { render, staticRenderFns } from "./kczcContent.vue?vue&type=template&id=2a3e872c&scoped=true"
import script from "./kczcContent.vue?vue&type=script&lang=ts"
export * from "./kczcContent.vue?vue&type=script&lang=ts"
import style0 from "./kczcContent.vue?vue&type=style&index=0&id=2a3e872c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3e872c",
  null
  
)

export default component.exports